//资源库
import ResourcePage from "@/views/model/resource/ResourcePage.vue";
import ResourceWhereUsed from "@/views/model/resource/ResourceWhereUsed.vue";
import ResourceHistory from "@/views/model/resource/ResourceHistory.vue";
import ResourceRelatedResource from "@/views/model/resource/resourceRelatedResource.vue";

import { ItemAttachment, Relationship, PageInfo } from "./commonModules";

export const Resource = {
  path: "/ResourcePage",
  component: ResourcePage,
  children: [
    {
      path: "/ResourceRelationship",
      component: Relationship,
    },
    {
      path: "/ResourceTitleBlock",
      // name: 'ResourceTitleBlock',
      component: PageInfo,
    },
    {
      path: "/ResourceRelatedResource",
      // name: 'ResourceRelatedResource',
      component: ResourceRelatedResource,
    },
    {
      path: "/ResourceRelatedtechnology",
      component: ResourceWhereUsed,
    },
    {
      path: "/ResourceAttachment",
      // name: 'ResourceAttachment',
      component: ItemAttachment,
    },
    {
      path: "/ResourceHistory",
      component: ResourceHistory,
    },
  ],
};
